const extractNumbers = (value = '') => {
  const numberPattern = /\d+/g
  return value.match(numberPattern) ?? [-1]
}

export default extractNumbers
